import { normalize } from 'normalizr'
import { fromJS } from 'immutable'
import { schemaLog } from '../schemas'
import axios from 'axios'

/**
 * 获取操作日志列表
 * @param {*String} options.deviceId 设备id
 * @param {*Number} options.currentPage 页码
 * @param {String} options.date 日期
 */
export const find = async ({ deviceId, currentPage, date } = {}) => {
  let productId = sessionStorage.getItem('productType')
  let path = `v2/solar-motes/audit-info/${deviceId}`
  if (productId === '16') {
    path = `repower/${path}`
  }
  const { data } = await axios.get(path, {
    params: {
      pageNo: currentPage,
      dateStr: date
    }
  })
  const { entities } = normalize(data, [ schemaLog ])
  return fromJS(entities)
}
